/**
 * Created by why on 2019/10/21.
 */
import {
  quartzList,
  addQuartz,
  updateQuartz,
  deleteQuartz,
  pauseQuartz,
  resumeQuartz
} from '@/api/quartz-manage'
export default {
  state: {
    list: [],
    loading: false,
    pageSize: 10,
    pageNum: 1,
    total: 0,
    modalLoading: false,
    deleteLoading: false,
    checkList: [],
    message: ''
  },
  mutations: {
    setList (state, userList) {
      state.list = userList
    },
    setLoading (state, loading) {
      state.loading = loading
    },
    setPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTotal (state, total) {
      state.total = total
    },
    setCheckList (state, checkList) {
      state.checkList = checkList
    },
    setSelectData (state, {list, loading, pageSize, pageNum, total}) {
      state.list = list
      state.loading = loading
      state.pageSize = pageSize
      state.pageNum = pageNum
      state.total = total
    },
    setModalLoading (state, loading) {
      state.modalLoading = loading
    },
    setDeleteLoading (state, loading) {
      state.deleteLoading = loading
    }
  },
  getters: {
    quartzList: state => state.list,
    queryLoading: state => state.loading,
    total1: state => state.total,
    quartzMessage: state => state.message,
    modalLoading: state => state.modalLoading,
    deleteLoading: state => state.deleteLoading
  },
  actions: {
    getQuartzList ({ state, commit }, {pageNum, pageSize}) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        quartzList({
          pageNum: pageNum,
          pageSize: pageSize
        }).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.pageSize
          const pageNum = data.pageNum
          const total = data.total
          const loading = false
          commit('setSelectData', {list, loading, pageSize, pageNum, total})
          resolve()
        }).catch(err => {
          commit('setLoading', false)
          reject(err)
        })
      })
    },
    addQuartz ({ state, commit }, data) {
      commit('setModalLoading', true)
      return new Promise((resolve, reject) => {
        addQuartz(data).then(res => {
          const message = res.data.message
          commit('setModalLoading', false)
          resolve(message)
        }).catch(err => {
          commit('setModalLoading', false)
          reject(err)
        })
      })
    },
    updateQuartz ({ state, commit }, data) {
      commit('setModalLoading', true)
      return new Promise((resolve, reject) => {
        updateQuartz(data).then(res => {
          const message = res.data.message
          commit('setModalLoading', false)
          resolve(message)
        }).catch(err => {
          commit('setModalLoading', false)
          reject(err)
        })
      })
    },
    pauseQuartz ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        pauseQuartz(data).then(res => {
          const message = res.data.message
          resolve(message)
        }).catch(err => {
          reject(err)
        })
      })
    },
    deleteQuartz ({ state, commit }, data) {
      commit('setDeleteLoading', true)
      return new Promise((resolve, reject) => {
        deleteQuartz(data).then(res => {
          const message = res.data.message
          commit('setDeleteLoading', false)
          resolve(message)
        }).catch(err => {
          commit('setDeleteLoading', false)
          reject(err)
        })
      })
    },
    resumeQuartz ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        resumeQuartz(data).then(res => {
          const message = res.data.message
          resolve(message)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/quartz-manage.js